export default __webpack_public_path__ + "static/media/Belt of the Darkwretch.88001855.jpg";